const eventsFieldsInit = {
    rehearsals: 0,
    raccords: 0,
    concerts: 0,
};

export const default_tariff = {'value': '-- new entry --', 'label': "-- new entry --", 'id': 0}

export const initialState = {
    // Core data
    staff: {},
    others: "",
    conductor: "",

    // Events
    events: eventsFieldsInit,
    eventDetail: [],
    details: false,

    // Rates
    rates: {
        client: {
            kzm: { concerts: 0, raccords: 0, rehearsals: 0 },
            mus: { concerts: 0, raccords: 0, rehearsals: 0 }
        },
        estro: {
            kzm: { concerts: 0, raccords: 0, rehearsals: 0 },
            mus: { concerts: 0, raccords: 0, rehearsals: 0 }
        }
    },

    // Costs
    costs: {
        renting: [{
            id: "X1",
            description: "X",
            client_cost: 0,
            estro_cost: 0,
            cost_type: "renting",
            display_type: "X",
        }],
        administration: [{
            id: "X1",
            description: "X",
            client_cost: 0,
            estro_cost: 0,
            cost_type: "administration",
            display_type: "X",
        }],
        transport: [{
            id: "X1",
            description: "X",
            name: "X",
            client_cost: 0,
            estro_cost: 0,
            cost_type: "transport",
            edit: false,
            display_type: "X",
        }],
        archiving: [{
            id: "X1",
            description: "X",
            client_cost: 0,
            estro_cost: 0,
            entity: "pcs",
            cost_type: "archiving",
            display_type: "X",
            name: "X",
        }]
    },

    // Transport specific
    transp30km: false,
    project30kmAway: {
        description: "Musicians",
        client_cost: 0.0,
        estro_cost: 0.0,
    },
    conductor30kmAway: {
        description: "Conductor",
        client_cost: 0.0,
        estro_cost: 0.0,
    },

    // Settings
    eventDuration: {
        rehearsal_duration: 0,
        raccord_duration: 0,
    },
    kzmProject: true,

    // Meta
    calculationName: "",
    calculationNotes: "",
    program: "",
    tariff: default_tariff,
    folder: null,
};

export const calculationReducer = (state, action) => {
    switch (action.type) {
        // === LOAD & RESET ===
        case 'LOAD_CALCULATION':
            return {
                ...state,
                ...action.payload
            };

        case 'RESET_CALCULATION':
            return initialState;

        // === TARIFF ===
        case 'SET_TARIFF':
            return {
                ...state,
                tariff: action.payload
            };

        case 'UPDATE_TARIFF_DATA':
            // Aktualizuj wszystko co związane z tariff
            return {
                ...state,
                rates: action.payload.rates,
                costs: action.payload.costs,
                eventDuration: action.payload.eventDuration,
                project30kmAway: action.payload.project30kmAway || state.project30kmAway,
                conductor30kmAway: action.payload.conductor30kmAway || state.conductor30kmAway,
            };

        // === STAFF ===
        case 'SET_STAFF':
            return {
                ...state,
                staff: action.payload
            };

        case 'SET_CONDUCTOR':
            return {
                ...state,
                conductor: action.payload
            };

        case 'SET_OTHERS':
            return {
                ...state,
                others: action.payload
            };

        // === EVENTS ===
        case 'SET_EVENTS':
            return {
                ...state,
                events: action.payload
            };

        case 'SET_EVENT_DETAIL':
            return {
                ...state,
                eventDetail: action.payload
            };

        case 'SET_DETAILS':
            return {
                ...state,
                details: action.payload
            };

        case 'SET_KZM_PROJECT':
            return {
                ...state,
                kzmProject: action.payload
            };

        // === RATES ===
        case 'UPDATE_RATES':
            // payload: { rateType: 'client'|'estro', category: 'kzm'|'mus', values: {...} }
            return {
                ...state,
                rates: {
                    ...state.rates,
                    [action.payload.rateType]: {
                        ...state.rates[action.payload.rateType],
                        [action.payload.category]: {
                            ...state.rates[action.payload.rateType][action.payload.category],
                            ...action.payload.values
                        }
                    }
                }
            };

        case 'SET_ALL_RATES':
            // payload: { client: {...}, estro: {...} }
            return {
                ...state,
                rates: action.payload
            };

        // === COSTS ===
        case 'UPDATE_COST':
            // payload: { costType: 'renting'|'administration'|'transport'|'archiving', data: [...] }
            return {
                ...state,
                costs: {
                    ...state.costs,
                    [action.payload.costType]: action.payload.data
                }
            };

        case 'SET_ALL_COSTS':
            // payload: { renting: [...], administration: [...], transport: [...], archiving: [...] }
            return {
                ...state,
                costs: action.payload
            };

        // === TRANSPORT ===
        case 'SET_TRANSP_30KM':
            return {
                ...state,
                transp30km: action.payload
            };

        case 'SET_PROJECT_30KM_AWAY':
            return {
                ...state,
                project30kmAway: action.payload
            };

        case 'SET_CONDUCTOR_30KM_AWAY':
            return {
                ...state,
                conductor30kmAway: action.payload
            };

        // === META ===
        case 'SET_CALCULATION_NAME':
            return {
                ...state,
                calculationName: action.payload
            };

        case 'SET_CALCULATION_NOTES':
            return {
                ...state,
                calculationNotes: action.payload
            };

        case 'SET_PROGRAM':
            return {
                ...state,
                program: action.payload
            };

        case 'SET_FOLDER':
            return {
                ...state,
                folder: action.payload
            };

        case 'SET_EVENT_DURATION':
            return {
                ...state,
                eventDuration: action.payload
            };

        default:
            return state;
    }
};
